import { Button, Icon } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const ExpanderCell = function ExpanderCellElement({ row }) {
    return (row.getCanExpand() ? (React.createElement("div", { style: { textAlign: 'center' } },
        React.createElement(Button, { iconButton: true, onClick: row.getToggleExpandedHandler() },
            React.createElement(Icon, { iconName: row.getIsExpanded() ? 'more-horizontal' : 'more-vertical' })))) : (React.createElement("div", null, "\uD83D\uDD35")));
};
export default ExpanderCell;
